import React, { Component } from 'react'
import { MenuContext } from '../context'
import Title from './Title'
import Loading from './Loading'
import Menu from './Menu'
export default class FeaturedMenu extends Component {
    static contextType = MenuContext;
    render() {
        // featuredMenu will come from the context.js in ComponentDidMount after filtered.
        // "this.context" means that you are using the component context globally from context.js
        const { loading, featuredMenu: menu } = this.context;
        this.menu = menu.map(menu => {

            return <Menu key={menu.id} menu={menu} />;
        });
        //console.log(menu);
        return (
            <section className="featured-menu">
                <Title title="featured Menu" />
                <div className="featured-menu-center">
                    {
                        loading ? <Loading /> : this.menu
                    }
                </div>

            </section>
        )
    }
}
